import { apiConfig } from 'core-lib/config/config';
import { getMethod } from 'core-lib/utils/apiV2';
import { ModelDetailType } from '../types/index';
import { getHeaders } from '../utils/headers';

const serializeVariantData = (res, variants,modelId) => {
  const result: any = {
    brandName: res?.variant_data?.brand_name || null,
    modelName: res?.variant_data?.model_name || null,
    bodyType: res?.variant_data?.body || null,
    launchDate: res?.variant_data?.launch_date || null,
    transmission: res?.variant_data?.transmission || null,
    variantName: res?.variant_data?.variant_display_name || '',
    price: res?.variant_data?.ex_showroom_price_slug || null,
    engineType: res?.variant_data?.engine || null,
    engineDisplacement: res?.variant_data?.engine_displacement || null,
    fuelType: res?.variant_data?.fuel || null,
    torque: res?.variant_data?.max_torque_slug || null,
    enginePower: res?.variant_data?.max_power_slug || null,
    brandIcon: res?.variant_data?.brand_logo || null,
    carImage: res?.variant_data?.model_image || null,
    variantsList: variants,
    detailedSpecifications: res?.specification_data,
    brandSlug: res?.variant_data?.brand_name_slug,
    modelSlug: res?.variant_data?.model_name_slug,
    variantLocaleList: res?.variant_locale_list,
    transmissionSlug: res?.variant_data?.transmission_slug || "",
    mileageSlug: res?.variant_data?.mileage_arai_slug || "",
    mileage: res?.variant_data?.mileage_arai || null,
    seatingCapacity: res?.variant_data?.seating_capacity || null,
    maxPowerSlug: res?.variant_data?.max_power_slug || "",
    maxTorqueSlug: res?.variant_data?.max_torque_slug || "",
    modelId : modelId
  };
  return result;
};

const fetchVariantDetails = async ({
  modelDetail,
  slug,
  id
}: {
  modelDetail: ModelDetailType,
  slug?: string,
  id?: number,
}
) => {
  if (!modelDetail) return null;
  let variant = null
  if (!id) { variant = modelDetail?.variants?.find((item) => item?.slug === slug); }
  const url = `${apiConfig('chariot')}/v1/variant/details?variant_id=${id ? id : variant?.variantKey
  }&source=seo`;
  const { response, error }: any = await getMethod({ endPoint: url, headers: getHeaders() });
  if (response) {
    return serializeVariantData(response?.data, modelDetail?.variants || null,modelDetail?.modelId);
  } else return null;
};
export default fetchVariantDetails;
